import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useAtom } from "jotai/index";

import { isOwner } from "@/lib/auth-predicates";
import MttAnalyticsPage from "@/pages/mtt-analytics-page";
import { meStore } from "@/store/store";

export const Route = createFileRoute("/mtt-analytics/")({
  component: Component,
});

function Component() {
  const [me] = useAtom(meStore);

  if (me?.stat_visualization.length === 0 && !isOwner(me)) {
    return <Navigate to="/" />;
  }

  return <MttAnalyticsPage />;
}
